import React from "react";
import Typical from "react-typical";
import "./Profile.css";
import ScrollService from "../../../utilities/ScrollService";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="cols-icon">
              {/* <a href="https://web.facebook.com/?_rdc=1&_rdr">
                <i className="fa fa-facebook-square" />
              </a> */}
              {/* <a href="#">
                <i className="fa fa-google-plus-square" />
              </a> */}
              {/* <a href="https://www.instagram.com/instructor_ehizeex/">
                <i className="fa fa-instagram" />
              </a>
              <a href="https://www.youtube.com/channel/UCSSr5ZDFbilpZ592_ycoAwA">
                <i className="fa fa-youtube-square" />
              </a> */}
              <a href="https://www.linkedin.com/in/belmiro-silva-a58b5917/" target="blank">
                <i className="fa fa-linkedin" />
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm <span className="highlighted-text">Miro</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "QA Software 😎",
                    1500,
                    "Focus on details...",
                    1500,
                    "Always learning... ",
                    1500,
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
            Knack for building and perform robust test cases to insure
            <br></br>that the application is delivery always "on point"!
            <br></br>I start diving in Automation Tests and hope to continues learning.
            </span>
          </div>

          <div className="profile-options">
            <button className="btn primary-btn"
            onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            > Contacts </button>
            <a href="CV_Belmiro_Silva.pdf" download="CV Belmiro Silva.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
